import { axiosInstance } from "@/api/axios";
import { AxiosRequestConfig } from "axios";

export type Payload = {
  name: string;
  unit_id?: string;
  expense_type_id: string;
};

export const getExpenseTypes = async (config: AxiosRequestConfig) => {
  const response = await axiosInstance.get("/expenses/types", config);
  return response.data;
};

export const getExpenseDescriptions = async (config: AxiosRequestConfig) => {
  const response = await axiosInstance.get("/expenses/descriptions", config);
  return response.data;
};

export const getExpenseUnits = async (config: AxiosRequestConfig) => {
  const response = await axiosInstance.get("/units", config);
  return response.data;
};

export const getExpenseSuppliers = async (config: AxiosRequestConfig) => {
  const response = await axiosInstance.get("/suppliers", config);
  return response.data;
};

export const getExpenseHistories = async (config?: AxiosRequestConfig) => {
  const params = config?.params;

  if (params?.sort) {
    params.sort = JSON.stringify(params.sort);
  }

  if (params?.filters) {
    params.filters = JSON.stringify(params.filters);
  }
  const response = await axiosInstance.get("/expenses", { params });
  return response.data;
};

export const addExpenseDescription = async (payload: Payload) => {
  const response = await axiosInstance.post("/expenses/descriptions", payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const reactivateExpenseDescription = async (id: string) => {
  const response = await axiosInstance.post(
    `/expenses/descriptions/${id}/reactivate`
  );
  return response.data;
};

export const addExpenseSupplier = async (payload: Payload) => {
  const response = await axiosInstance.post("/suppliers", payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const reactivateExpenseSupplier = async (id: string) => {
  const response = await axiosInstance.post(`/suppliers/${id}/reactivate`);
  return response.data;
};

// Updated bulk create to only send draft IDs
export const createExpensesBulk = async () => {
  const response = await axiosInstance.post(
    "/expenses/bulk",
    {},
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};
